import React from "react";
import { notification } from "antd";
import { BsFillCheckCircleFill } from "react-icons/bs";
import { IoAlertCircle } from "react-icons/io5";
import { AiFillWarning } from "react-icons/ai";

import "./alertNotification.css";
import { FaGrinBeam, FaRegSmileBeam, FaSmileBeam } from "react-icons/fa";

// types success, info, warning, error
// define CSS of the type that is not in the .css file
// also import icon and set as per type if not present
export const alertNotification = (type, message, Stages, messageRoute , messageErrors,duration=3) => {
  let icon = null;
  if (type === "success") {
    icon = <BsFillCheckCircleFill style={{ color: "#fff" }} />;
  }
  if (type === "warning") {
    icon = <IoAlertCircle style={{ color: "#fff" }} />;
  }
  if (type === "error") {
    icon = <AiFillWarning style={{ color: "#fff" }} />;
  }
  if (type === "success" && Stages) {
    icon = <FaRegSmileBeam style={{ color: "#fff" }} size={40} />;
  }

  return (
    <div className="alertNotificationAppWrap" style={{zIndex: '4444'}}>
      {notification[type]({
        message: message ? message : type,
        duration:duration?duration: messageErrors ? 6 : 4,
        className: `${
          Stages ? "Stages-alert" : "alertNotificationApp"
        }  ${type}`,
        top: 0,
        icon,
        maxCount: 4,
        btn: messageErrors ? null : (
          <>
            <span className="chatButton-Mobile" onClick={messageRoute}>
              <span>Chat with the employer</span>
              {/* <img src={ChatIconGreen} /> */}
            </span>
          </>
        ),
        // closeIcon: <img src={closeIcon} alt="close" />,
      })}
    </div>
  );
};

